import {
	getCalculationTypeColor,
	getCalculationTypeTranslationKey,
} from "@msuite/utils/partnerships";
import type { Enums } from "@msuite/utils/types";
import { useTranslation } from "../localization";
import type { ClassNameProps } from "../types";
import { Tag } from "./tag";

/** Props Interface */
interface CalculationTypeTagProps extends ClassNameProps {
	type: Enums<"assignmentCalculationType">;
}

export function CalculationTypeTag({ type, className }: CalculationTypeTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Tag
			variant="plain"
			color={getCalculationTypeColor(type)}
			className={className}
		>
			{t(getCalculationTypeTranslationKey(type))}
		</Tag>
	);
}
